import { render, staticRenderFns } from "./failurePage.vue?vue&type=template&id=ef32a57e&scoped=true"
import script from "./failurePage.vue?vue&type=script&lang=js"
export * from "./failurePage.vue?vue&type=script&lang=js"
import style0 from "./failurePage.vue?vue&type=style&index=0&id=ef32a57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef32a57e",
  null
  
)

export default component.exports